<template>
  <date-range-picker
      v-model="selfDateRange"
      :locale-data="localeData"
      @update="updateRangePicker"
      :ranges="presetDateRage"
      :min-date="minDate"
      :max-date="maxDate"
      :opens="position"
  >

  </date-range-picker>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
  name: "SelfDateRangePicker",
  components: {
    DateRangePicker,
  },
  props: {
    initRange: Object,// {startDate, endDate}
    update: Function,
    minDate: String,
    maxDate: String,
    position: String,
    defaultInit: Boolean,
  },
  data() {
    let defaultDate = new Date('2017-01-01')
    let today = new Date()
    // today.setHours(0, 0, 0, 0)
    let yesterday = new Date()
    yesterday.setDate(today.getDate() - 1)
    // yesterday.setHours(0, 0, 0, 0);
    let weekAgo = new Date()
    weekAgo.setDate(today.getDate() - 7)
    // weekAgo.setHours(0, 0, 0, 0);
    let day_30 = new Date()
    day_30.setDate(today.getDate() - 30)
    // day_30.setHours(0, 0, 0, 0);
    let thisMonth = new Date(today.getFullYear(), today.getMonth(), 1)
    // thisMonth.setHours(0, 0, 0, 0);
    let day_365 = new Date()
    day_365.setDate(today.getDate() - 365)
    let monthAgo = new Date()
    monthAgo.setMonth(today.getMonth() - 1)
    // day_365.setHours(0, 0, 0, 0);
    const preset = {
      'Сегодня': [today, today],
      'Вчера': [yesterday, yesterday],
      'Неделя': [weekAgo, yesterday],
      '30 дней': [day_30, yesterday],
      'Этот месяц': [thisMonth, today],
      'Предыдущий месяц': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
      'Текущий год': [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)],
      '365 дней': [day_365, yesterday],
    }
    return {
      localeData: {
        direction: 'ltr',
        format: 'dd.mm.yyyy',
        separator: ' - ',
        applyLabel: 'Применить',
        cancelLabel: 'Отмена',
        weekLabel: 'W',
        customRangeLabel: 'Пользовательский диапазон',
        daysOfWeek: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        monthNames: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
        firstDay: 1,
      },
      presetDateRage: preset,
      selfDateRange: {
        startDate: defaultDate,
        endDate: today,
      },
    }
  },
  methods: {
    updateRangePicker: function () {
      // this.dateRange = Object.assign({}, this.selfDateRange)
      this.update({
        from: this.dateToString(this.selfDateRange.startDate),
        to: this.dateToString(this.selfDateRange.endDate),
        date: {
          from: this.selfDateRange.startDate,
          to: this.selfDateRange.endDate
        }
      })
    },
  },
  computed: {
  },
  mounted() {

  },
  created() {
    if (this.initRange !== undefined && this.initRange.startDate !== undefined && this.initRange.endDate !== undefined) {
      this.selfDateRange = Object.assign({}, this.initRange)
    } else {
      if (this.defaultInit !== undefined && this.defaultInit && this.selfDateRange.startDate !== undefined
          && this.selfDateRange.endDate !== undefined
      ) {
        this.updateRangePicker()
      }
    }
  }
}
</script>

<style>
.form-control {
  font-size: 0.9rem;
  height: calc(1.5em + 0.65rem);
}
</style>

<style scoped>

</style>